import styled from 'styled-components';
import { Radio } from 'antd';

export default styled(Radio)`
  display: block;
  height: 30px;
  line-height: 30px;
`;
